import React from "react";
import { useSelector } from "react-redux";

import { OnboardingProgram } from "../../models/status";
import { getOnboardingSignedIn } from "../../redux/selectors/authSelectors";
import { IdAzureSelected, IdXboxSelected, PitchSelected } from "./SelectedPrograms";
import { SignedInNoSelectedProgram } from "./SignedInNoSelectedProgram";
import { SignedOutNoSelectedProgram } from "./SignedOutNoSelectedProgram";

type ProgramSelectorProps = Readonly<{
  selectedProgram?: OnboardingProgram;
}>;

export const ProgramSelector = ({ selectedProgram }: ProgramSelectorProps) => {
  const isSignedIn = useSelector(getOnboardingSignedIn);

  if (!selectedProgram) {
    // User signed-out
    return !isSignedIn ? <SignedOutNoSelectedProgram /> : <SignedInNoSelectedProgram />;
  }

  // User signed in with program selected
  switch (selectedProgram) {
    case OnboardingProgram.IdXboxProgram:
      return <IdXboxSelected />;
    case OnboardingProgram.IdAzureProgram:
      return <IdAzureSelected />;
    case OnboardingProgram.PitchProgram:
      return <PitchSelected />;
    default:
      return null;
  }
};
